import React from "react";
import ITStaffingIntro from "./Intro";
import RecruitmentPhilosophy from "./Philosophy";
import WhyChooseKapilTech from "./WhyChoose";
import RecruitmentServices from "./Services";
import TalentTransformation from "./Talent";
import ReadyToHire from "./ReadyToHire";
import GetInTouch from "./GetInTouch";

const EmployerPage = () => {
  return (
    <>
      <ITStaffingIntro/>
      <RecruitmentPhilosophy/>
      <WhyChooseKapilTech/>
      <RecruitmentServices/>
      <TalentTransformation/>
      {/* <ReadyToHire/> */}
      <GetInTouch/>
    </>
  );
};

export default EmployerPage;
